import { useEffect } from "react";

import { dataMappingForFilters, filterData } from "../../../services";
import { Box, Flex } from "../../cores";
import {
  useComparePreviusValuesWithCurrent,
  useGetSdlConfig,
  useUpdateRowData,
  useViewContext,
} from "../../hooks";
import { IconClose, IconScales } from "../../icons";
import { Button } from "../../molecules";
import { resetFilter } from "../../molecules/Filters";
import { sortTable } from "../../molecules/Table/SortTable";
import {
  ContentDescriptionContainer,
  FilterCollection,
  TableWithPages,
} from "../../organisms";
import { useTableContext } from "../../providers";
import { IKeyStringAndValue, IOptions } from "../../types/Types";

export default function View() {
  const {
    listView,
    filteredData,
    setFilteredData,
    filterOptions,
    setFilterOptions,
    setSortedField,
    arrowState,
    setArrowState,
    setCurrentPage,
    selected,
    selectedData,
    setSelectedData,
    isCompare,
    setIsCompare,
    setInputValue,
  } = useTableContext();
  const data = useUpdateRowData(listView);
  const sdlConfig = useGetSdlConfig(listView).data as Array<IOptions>;
  const { isMobile } = useViewContext();

  const isEmpty =
    Object.values(filterOptions).every((a) => a === "default" || a === "") ||
    Object.keys(filterOptions).length === 0
      ? true
      : false;
  //Sets data value for the snapchot when Make filter changes
  const { filteredDataSnapshot, setFirstFilterValue } =
    useComparePreviusValuesWithCurrent(
      filteredData,
      filterOptions,
      setInputValue
    );

  useEffect(() => {
    sortTable(
      sdlConfig[0].key,
      filterData(isCompare ? selectedData : data, sdlConfig, filterOptions),
      setFilteredData,
      arrowState ? !!arrowState : !arrowState,
      setCurrentPage
    );
    setArrowState(
      !arrowState
        ? (prevArrowState) => !!prevArrowState
        : (prevArrowState) => !prevArrowState
    );
    setSortedField(sdlConfig[0].key);
    setCurrentPage(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, filterOptions, isCompare, selectedData]);

  const handleReset = () => {
    resetFilter(
      isCompare ? selectedData : data,
      setFilteredData,
      setFilterOptions,
      setCurrentPage,
      setInputValue,
      setFirstFilterValue
    );
  };

  const handleCompare = () => {
    const selectedDataFilter = data.filter((element: IKeyStringAndValue) => {
      return selected.includes(element);
    });
    setSelectedData(selectedDataFilter);
    resetFilter(
      isCompare ? data : selectedDataFilter,
      setFilteredData,
      setFilterOptions,
      setCurrentPage,
      setInputValue,
      setFirstFilterValue
    );
    setIsCompare(isCompare ? false : true);
  };

  return (
    <Box sx={{ maxWidth: "1240px", margin: "auto", paddingTop: 20 }}>
      <FilterCollection
        filteredCategories={
          dataMappingForFilters({ filteredData: filteredDataSnapshot })
            .categories
        }
        allCategories={dataMappingForFilters({ filteredData: data }).categories}
      />
      <Flex
        sx={{
          flexWrap: "wrap",
          marginY: 14,
          flexDirection: "column",
          width: isMobile ? "calc(100% - 32px)" : "fit-content",
          marginBottom: !isMobile ? "-49px" : null,
          "> button": {
            margin: "14px 16px",
          },
        }}
      >
        <Button
          text={"Rensa valda filter"}
          size="md"
          fullWidth={isMobile}
          disabled={isEmpty}
          onClick={handleReset}
          iconLeft={IconClose}
        />
        <Button
          text={isCompare ? "Avbryt jämför" : "Jämför markerade objekt"}
          iconLeft={IconScales}
          size="md"
          fullWidth={isMobile}
          disabled={!isCompare && selected.length < 2}
          onClick={handleCompare}
          variant={"secondary"}
        />
      </Flex>
      <ContentDescriptionContainer columns={sdlConfig} />
      <TableWithPages data={data} />
    </Box>
  );
}
